import { message } from "antd";
export const displayMessage = (type, messageValue) => {
  message[type](messageValue);
};
